import React from 'react';

const VARIANT_CLASSES = {
  primary: 'bg-primary-600 text-white hover:bg-primary-700',
  success: 'bg-green-600 text-white hover:bg-green-700',
  info: 'bg-sky-600 text-white hover:bg-sky-700',
  warning: 'border border-yellow-400 text-yellow-700 hover:bg-yellow-50 bg-white',
  danger: 'border border-red-300 text-red-600 hover:bg-red-50 bg-white',
  ghost: 'border border-gray-200 text-gray-700 hover:bg-gray-50 bg-white',
  outlinePrimary: 'border border-primary-600 text-primary-600 hover:bg-primary-50 bg-white',
  soft: 'border border-green-200 text-green-700 hover:bg-green-50 bg-white',
};

const SIZE_CLASSES = {
  sm: 'px-3 py-2 text-sm',
  md: 'px-4 py-2.5 text-sm',
  lg: 'px-4 py-3 text-base',
};

const UiButton = ({
  children,
  icon: Icon = null,
  variant = 'primary',
  size = 'md',
  className = '',
  type = 'button',
  disabled = false,
  ...props
}) => {
  return (
    <button
      type={type}
      disabled={disabled}
      className={`inline-flex items-center justify-center gap-2 rounded-xl font-semibold transition disabled:cursor-not-allowed disabled:opacity-50 ${VARIANT_CLASSES[variant] || VARIANT_CLASSES.primary} ${SIZE_CLASSES[size] || SIZE_CLASSES.md} ${className}`}
      {...props}
    >
      {Icon ? <Icon size={size === 'lg' ? 18 : 16} /> : null}
      {children}
    </button>
  );
};

export default UiButton;
